import React from 'react'
import {Box, Typography} from '@mui/material'
import Card from 'src/components-new/layout/Card'
import EmptyState from 'src/components-new/layout/EmptyState'
import {CARD_BORDER_COLOR, CARD_BORDER_RADIUS, NEUTRAL_SCALE} from 'src/theme-new/tokens'

interface DiseasesSectionProps {
  fields: Record<string, any>
  data: Record<string, any>
}

export default function DiseasesSection({fields, data}: DiseasesSectionProps): JSX.Element | null {
  if (!fields?.diseases || fields?.diseases?.hidden) return null

  const diseases: Record<string, any>[] = data?.diseases ?? []

  return (
    <Card title="Patologie">
      {diseases.length === 0 ? (
        <EmptyState title="Nessun risultato" description="Nessuna patologia registrata" />
      ) : (
        <Box sx={{display: 'grid', gridTemplateColumns: {xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)'}, gap: 2}}>
          {diseases.map((disease, index) => (
            <Box
              key={disease._id ?? index}
              sx={{
                border: `1px solid ${CARD_BORDER_COLOR}`,
                borderRadius: CARD_BORDER_RADIUS,
                p: 2,
                bgcolor: 'background.paper',
                display: 'flex',
                flexDirection: 'column',
                gap: 0.5,
              }}
            >
              <Typography variant="subtitle2" sx={{fontWeight: 600}}>
                {disease.name ?? '—'}
              </Typography>
              <Typography variant="body2" sx={{color: disease.description ? NEUTRAL_SCALE[500] : NEUTRAL_SCALE[300]}}>
                {disease.description || '—'}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Card>
  )
}
